"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrintLabels = void 0;
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const checkbox_1 = require("client/components/material/checkbox/checkbox");
const floating_page_1 = require("client/components/page/floating-page");
const ui_1 = require("client/components/ui");
const print_labels_1 = require("client/modules/labels/print-labels");
const invoice_1 = require("client/modules/orders/modules/orders-detail/components/order-claims/invoice");
const patient_waiver_1 = require("client/modules/orders/modules/orders-detail/components/order-claims/patient-waiver");
const warning_label_1 = require("client/modules/orders/modules/orders-detail/components/order-claims/warning-label");
const store_1 = require("client/modules/orders/store");
const store_2 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const react_1 = require("react");
require("./print-labels.less");
const printOptionsDummy = {
    // billingSheet: false,
    claimLabel: false,
    invoice: false,
    monograph: false,
    patientWaiver: false,
    warningLabel: false,
    pharmacyLabel: false
};
let PrintLabels = class PrintLabels extends react_1.Component {
    constructor(props) {
        super(props);
        this.labelDocs = {
            // billingSheet: true,
            claimLabel: true,
            invoice: true,
            monograph: true,
            patientWaiver: true,
            warningLabel: true,
            pharmacyLabel: true
        };
        this.labels = {
            pharmacyLabel: true
        };
        this.showLabels = false;
        this.showLabelDocs = false;
        this.loading = false;
        this.loadingLabels = false;
        this.loadingDocs = false;
        this.loadFromPads = async (orderId, claimId) => {
            let cId = claimId || null;
            await store_1.ordersStore.readOrder(orderId);
            await store_1.ordersStore.loadClaims(orderId);
            if (!cId) {
                const firstClaim = store_1.ordersStore.order.value.claims.find((claim) => claim.signature);
                cId = firstClaim.id;
            }
            await store_1.ordersStore.readClaim(cId);
        };
        this.renderLabelsWarnings = (claim, selectedClaims) => {
            const orderId = claim.order.id;
            const claimId = claim.id;
            this.loadFromPads(orderId, claimId);
            return (React.createElement("div", { className: "print-labels__labels" },
                React.createElement(patient_waiver_1.PatientWaiver, null),
                React.createElement("hr", null),
                React.createElement(warning_label_1.WarningLabel, null)));
        };
        this.renderLabelsInvoice = (orderId) => {
            this.loadFromPads(orderId);
            return (React.createElement("div", { className: "print-labels__labels" },
                React.createElement(invoice_1.Invoice, null)));
        };
        this.normalizeLabel = (label) => {
            let checkboxLabel;
            switch (label) {
                // case "billingSheet":
                //   checkBoxLabel = "Billing Sheet";
                //   break;
                case "claimLabel":
                    checkboxLabel = "Claim Label";
                    break;
                case "invoice":
                    checkboxLabel = "Invoice";
                    break;
                case "monograph":
                    checkboxLabel = "Monograph";
                    break;
                case "patientWaiver":
                    checkboxLabel = "Patient Waiver";
                    break;
                case "warningLabel":
                    checkboxLabel = "Warning Label";
                    break;
                case "pharmacyLabel":
                    checkboxLabel = "Pharmacy Label";
                    break;
                default:
                    checkboxLabel = "N/A";
            }
            return checkboxLabel;
        };
        this.renderOptionLabelDocs = () => (React.createElement("div", { className: "options-label" },
            React.createElement("div", { className: "print-labels__title" }, "Documents"),
            React.createElement("div", { className: "print-labels__form" },
                React.createElement("div", { className: "inventory__form__description" }, "Select the documents you want to print"),
                React.createElement(ui_1.UiForm, { buttons: ["Print Docs"], onSubmit: this.handleSubmit("documents"), loading: this.loadingDocs },
                    React.createElement("div", { className: "print-labels__label-selection" },
                        React.createElement("div", { className: "label-options" }, Object.keys(this.labelDocs).map((label, index) => (React.createElement(checkbox_1.MaterialCheckbox, { key: index, checked: this.labelDocs[label], label: this.normalizeLabel(label), onAction: () => this.handleClickCheckbox(label) })))))))));
        this.renderOptionLabels = () => (React.createElement("div", { className: "options-label" },
            React.createElement("div", { className: "print-labels__title" }, "Pharmacy Label"),
            React.createElement("div", { className: "print-labels__form" },
                React.createElement("div", { className: "inventory__form__description" }, "Select the documents you want to print"),
                React.createElement(ui_1.UiForm, { buttons: ["Print Labels"], onSubmit: this.handleSubmit("labels"), loading: this.loadingLabels },
                    React.createElement("div", { className: "print-labels__label-selection" },
                        React.createElement("div", { className: "label-options" }, Object.keys(this.labels).map((label, index) => (React.createElement(checkbox_1.MaterialCheckbox, { key: index, checked: this.labels[label], label: this.normalizeLabel(label), onAction: () => this.handleClickCheckbox(label) })))))))));
        this.handleClickCheckbox = (label) => {
            this.labelDocs[label] = !this.labelDocs[label];
        };
        this.generatePrintOptions = (type) => {
            let printOptions;
            switch (type) {
                case "documents":
                    printOptions = Object.assign(Object.assign({}, printOptionsDummy), this.labelDocs);
                    break;
                case "labels":
                    printOptions = Object.assign(Object.assign({}, printOptionsDummy), this.labels);
                    break;
                default:
                    break;
            }
            return printOptions;
        };
        this.printAll = async (claims, type) => {
            if (type === "all" || type === "saveToDB") {
                this.loadingDocs = true;
            }
            else {
                this.loadingLabels = true;
            }
            try {
                const labelStack = await print_labels_1.labelsManager.generateLabelStack(claims, type);
                await store_1.ordersStore.printLabels(labelStack, type);
            }
            catch (err) {
                console.error("Error print all", err);
            }
            finally {
                this.loadingDocs = false;
                this.loadingLabels = false;
            }
        };
        this.handleSubmit = (type) => async () => {
            if (!(this.props.params && this.props.params.length === 2)) {
                console.error("params length is not 2");
                return;
            }
            this.loadingDocs = type === "documents";
            this.loadingLabels = type === "labels";
            try {
                const printOptions = this.generatePrintOptions(type);
                const orderId = parseInt(this.props.params[0], 10);
                const rxId = parseInt(this.props.params[1], 10);
                const realClaimId = await store_1.ordersStore.getClaimId(orderId, rxId);
                if (!realClaimId) {
                    console.error("Error: claimId from rxId not found");
                    return;
                }
                await store_1.ordersStore.readOrder(orderId);
                await store_1.ordersStore.readClaim(realClaimId);
                await store_1.ordersStore.loadClaims(orderId);
                const claim = store_1.ordersStore.claim.value;
                const labelStack = await print_labels_1.labelsManager.generateLabelStack([claim], type, printOptions);
                await store_1.ordersStore.printLabels(labelStack);
            }
            catch (err) {
                console.error("Error printing labels", err);
            }
            finally {
                this.loadingDocs = false;
                this.loadingLabels = false;
            }
        };
        this.svgRef = React.createRef();
        this.canvasRef = React.createRef();
        this.imageRef = React.createRef();
    }
    async componentWillMount() {
        const orderId = Number(this.props.params[0]);
        if (orderId) {
            await store_1.ordersStore.readOrder(orderId);
        }
    }
    async componentDidMount() {
        const orderId = Number(this.props.params[0]);
        const claimId = Number(this.props.params[1]);
        if (claimId && orderId) {
            await store_1.ordersStore.readOrder(orderId);
            await store_1.ordersStore.loadClaims(orderId);
            await store_1.ordersStore.readClaim(claimId);
        }
    }
    componentWillUnmount() {
        if (this.signatureInterval) {
            window.clearInterval(this.signatureInterval);
        }
    }
    async componentWillReceiveProps(props) {
        const oldOrderId = Number(this.props.params[0]);
        const newOrderId = Number(props.params[0]);
        if (newOrderId && oldOrderId !== newOrderId) {
            await store_1.ordersStore.readOrder(newOrderId);
        }
        const oldClaimId = Number(this.props.params[1]);
        const newClaimId = Number(props.params[1]);
        if (newClaimId && oldClaimId !== newClaimId) {
            await store_1.ordersStore.readClaim(newClaimId);
        }
    }
    render() {
        const { order: { value } } = store_1.ordersStore;
        return (React.createElement("div", { className: "print-labels" }, store_2.usersStore.permissions.ReadPrint ? (React.createElement(React.Fragment, null,
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement(kpi_title_1.KpiTitle, { label: value
                        ? `${value.patient.firstName} ${value.patient.lastName}`
                        : "", subLabel: value ? `#${value.id}` : "" })),
            React.createElement(floating_page_1.FloatingPage, null,
                React.createElement("div", { className: "print-labels__body" },
                    React.createElement("div", { className: "print-labels__options-container" },
                        this.renderOptionLabelDocs(),
                        this.renderOptionLabels()))))) : (store_2.usersStore.showLock())));
    }
};
__decorate([
    mobx_1.observable
], PrintLabels.prototype, "labelDocs", void 0);
__decorate([
    mobx_1.observable
], PrintLabels.prototype, "labels", void 0);
__decorate([
    mobx_1.observable
], PrintLabels.prototype, "showLabels", void 0);
__decorate([
    mobx_1.observable
], PrintLabels.prototype, "showLabelDocs", void 0);
__decorate([
    mobx_1.observable
], PrintLabels.prototype, "loading", void 0);
__decorate([
    mobx_1.observable
], PrintLabels.prototype, "loadingLabels", void 0);
__decorate([
    mobx_1.observable
], PrintLabels.prototype, "loadingDocs", void 0);
PrintLabels = __decorate([
    mobx_react_1.observer
], PrintLabels);
exports.PrintLabels = PrintLabels;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-detail/components/order-claims/print-labels/print-labels.tsx
// module id = 2988
// module chunks = 0 1